import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';
import { LIVE_LINK } from '../helpers/url_helper'
// This service handles the API interactions for logistic fees, specifically for deliveries.
export const logDelsApi = createApi({
  reducerPath: 'logDelsApi',
  baseQuery: fetchBaseQuery({ baseUrl: `${LIVE_LINK}/deliveries` }),
  // tagTypes: ['delEMSMN'],
  tagTypes: ['delDHL', 'delFedEx', 'delEMS', 'delEMSMC', 'delEMSMN', 'delOthers'],
  endpoints: (build) => ({
    fetchAllLogDeliveries: build.query({
      query: (data) => ({ url: '/', method: 'PUT', body: data }),
      providesTags: () => [{ type: 'delDHL', id: 'LIST' }, { type: 'delFedEx', id: 'LIST' }, { type: 'delEMS', id: 'LIST' }, { type: 'delEMSMC', id: 'LIST' }, { type: 'delEMSMN', id: 'LIST' }, { type: 'delOthers', id: 'LIST' }]
    }),
    filterLogDeliveries: build.query({
      query: (filterFormValues) => ({
        url: '/filtered',
        method: 'POST',
        body: filterFormValues,
      }),
      providesTags: () => [{ type: 'delDHL', id: 'LIST' }, { type: 'delFedEx', id: 'LIST' }, { type: 'delEMS', id: 'LIST' }, { type: 'delEMSMC', id: 'LIST' }, { type: 'delEMSMN', id: 'LIST' }, { type: 'delOthers', id: 'LIST' }]
    }),
    // addLogDelivery: build.mutation({
    //   query: (newRow) => ({
    //     url: '/',
    //     method: 'POST',
    //     body: newRow
    //   }),
    //   async onQueryStarted(newRow, { dispatch, queryFulfilled }) {
    //     const patchResults = [];
    //     try {
    //       const { data } = await queryFulfilled;
    //       patchResults.push(
    //         dispatch(
    //           logDelsApi.util.updateQueryData('fetchAllLogDeliveries', newRow[0].filterFormValues, (draft) => {
    //             const tabMapping = {
    //               "delDHL": 1,
    //               "delFedEx": 2,
    //               "delEMS": 3,
    //               "delEMSMC": 4,
    //               "delEMSMN": 5,
    //               "delOthers": 6
    //             };
    //             newRow.forEach(row => {
    //               const formattedRow = {
    //                 _id: data._id,
    //                 clientName: row.clientName || "",
    //                 country: row.country || "",
    //                 delFee: row.delFee || "",
    //                 delService: row.delService || "",
    //                 delServiceCommon: row.delService || "",
    //                 delivered: row.delivered || "",
    //                 invoiceNo: row.oneCOrder || "",
    //                 month: row.month || "",
    //                 year: row.year || "",
    //                 sendDate: new Date(row.sendDate).toISOString(),
    //                 manager: {
    //                   _id: row.manager || "",
    //                 },
    //                 delInfo: {
    //                   trackingNo: row.trackingNo || "",
    //                   delFee: row.delFee || "",
    //                   delPaidDate: row.delPaidDate || null,
    //                   delInvoiceNo: row.delInvoiceNo || "",
    //                   comment: row.comment || ""
    //                 },
    //                 logInfo: {
    //                   logService: row.logService || "",
    //                   logName: row.logName || "",
    //                   logDocs: row.logDocs || "",
    //                   depDate: new Date(row.sendDate).toISOString() || "",
    //                   delCost: row.delCost || "",
    //                   delCostVAT: row.delCostVAT || "",
    //                   delivery: row.delivery || "",
    //                   comment: row.comment || "",
    //                   delPaidDate: row.delPaidDate && new Date(row.delPaidDate).toISOString() || "",
    //                   logCost: row.logCost || "",
    //                   logCostCurrency: row.logCostCurrency || ""
    //                 },
    //                 delStatus: [],
    //                 trackingCntr: [],
    //                 canBeDeleted: true
    //               };
    //               // Find the correct delivery tab
    //               const tabKey = Object.keys(tabMapping).find(key => tabMapping[key] === row.dataId);
    //               if (tabKey && draft[tabKey]) {
    //                 draft[tabKey].push(formattedRow);
    //               }
    //             });
    //           })
    //         )
    //       );
    //     } catch {
    //       patchResults.forEach(p => p.undo());
    //     }
    //   },

    // }),
    
    addLogDelivery: build.mutation({
      query: (newRows) => ({
        url: '/',
        method: 'POST',
        body: newRows,
      }),

      async onQueryStarted(newRows, { dispatch, queryFulfilled }) {
        const patchResults = [];

        try {
          const { data } = await queryFulfilled;

          const { defaultValues, filterFormValues } = newRows[0]; // 👈 must be passed in from UI

          const tabMapping = {
            delDHL: 1,
            delFedEx: 2,
            delEMS: 3,
            delEMSMC: 4,
            delEMSMN: 5,
            delOthers: 6,
          };

          const addToDraft = (draft) => {
            newRows.forEach((row) => {
              const formattedRow = {
                _id: data._id, // if backend returns array, adjust here
                clientName: row.clientName || "",
                country: row.country || "",
                delFee: row.delFee || "",
                delService: row.delService || "",
                delServiceCommon: row.delService || "",
                delivered: row.delivered || "",
                invoiceNo: row.oneCOrder || "",
                month: row.month || "",
                year: row.year || "",
                sendDate: row.sendDate ? new Date(row.sendDate).toISOString() : "",
                manager: { _id: row.manager || "" },
                delInfo: {
                  trackingNo: row.trackingNo || "",
                  delFee: row.delFee || "",
                  delPaidDate: row.delPaidDate || null,
                  delInvoiceNo: row.delInvoiceNo || "",
                  comment: row.comment || ""
                },
                logInfo: {
                  logService: row.logService || "",
                  logName: row.logName || "",
                  logDocs: row.logDocs || "",
                  depDate: row.sendDate ? new Date(row.sendDate).toISOString() : "",
                  delCost: row.delCost || "",
                  delCostVAT: row.delCostVAT || "",
                  delivery: row.delivery || "",
                  comment: row.comment || "",
                  delPaidDate: row.delPaidDate ? new Date(row.delPaidDate).toISOString() : "",
                  logCost: row.logCost || "",
                  logCostCurrency: row.logCostCurrency || ""
                },
                delStatus: [],
                trackingCntr: [],
                canBeDeleted: true
              };

              const tabKey = Object.keys(tabMapping).find(
                (key) => tabMapping[key] === row.dataId
              );

              if (tabKey && draft[tabKey]) {
                draft[tabKey].unshift(formattedRow); // 👈 or push()
              }
            });
          };

          // 1️⃣ BASE cache (MUST use defaultValues)
          patchResults.push(
            dispatch(
              logDelsApi.util.updateQueryData(
                'fetchAllLogDeliveries',
                defaultValues,
                addToDraft
              )
            )
          );

          // 2️⃣ FILTERED cache (use exact filter args, only if active)
          if (filterFormValues) {
            patchResults.push(
              dispatch(
                logDelsApi.util.updateQueryData(
                  'filterLogDeliveries',
                  filterFormValues,
                  addToDraft
                )
              )
            );
          }

        } catch {
          patchResults.forEach((p) => p.undo());
        }
      },
    }),

    
    updateLogDelivery: build.mutation({
      query: (updatedRow) => ({
        url: `/${updatedRow._id}`,
        method: 'PUT',
        body: updatedRow,
      }),

      async onQueryStarted(updatedRow, { dispatch, queryFulfilled }) {
        const patchResults = [];

        try {
          await queryFulfilled;
          console.log('Updating base data cache for:', updatedRow.filterFormValues);
          // 1️⃣ Update BASE data (defaultValues)
          patchResults.push(
            dispatch(
              logDelsApi.util.updateQueryData('fetchAllLogDeliveries', updatedRow.defaultValues, (draft) => {
                const groups = ['delDHL', 'delFedEx', 'delEMS', 'delEMSMC', 'delEMSMN', 'delOthers'];
                for (const key of groups) {
                  const item = draft[key]?.find(r => r._id === updatedRow._id);
                  if (item) Object.assign(item, updatedRow);
                }
              })
            )
          );

          // 2️⃣ Update FILTERED data
          if (updatedRow.filterFormValues) {
            console.log('Updating filtered data cache for:', updatedRow.filterFormValues);
            patchResults.push(
              dispatch(
                logDelsApi.util.updateQueryData('filterLogDeliveries', updatedRow.filterFormValues, (draft) => {
                  const groups = ['delDHL', 'delFedEx', 'delEMS', 'delEMSMC', 'delEMSMN', 'delOthers'];
                  for (const key of groups) {
                    const item = draft[key]?.find(r => r._id === updatedRow._id);
                    if (item) Object.assign(item, updatedRow);
                  }
                })
              )
            );
          }

        } catch {
          patchResults.forEach(p => p.undo());
        }
      },
    }),
    deleteLogDelivery: build.mutation({
      query: (id) => ({
        url: `/${id.rowToDelete}`,
        method: 'DELETE'
      }),
      async onQueryStarted(id, { dispatch, queryFulfilled }) {
        console.log(id)
        const filterValues = id.filterFormValues;
        // const ts = id.ts;
        // const newFilter = ts ? {filterValues, _ts: ts} : filterValues;
        // console.log(newFilter);
        const patchResult = dispatch(
          logDelsApi.util.updateQueryData('fetchAllLogDeliveries', id.filterFormValues, (draft) => {
            const arrays = ['delDHL', 'delFedEx', 'delEMS', 'delEMSMC', 'delEMSMN', 'delOthers'];
            for (const key of arrays) {
              const index = draft[key]?.findIndex((row) => row._id === id.rowToDelete);
              if (index !== -1) {
                draft[key].splice(index, 1); // Remove item optimistically
              }
            }
          })
        );
        try {
          await queryFulfilled;
        } catch {
          patchResult.undo(); // Revert optimistic deletion on failure
        }
      }
    })
  })
});